import "/vercel/path0/example/node_modules/react-native/Libraries/Core/InitializeCore.js";
/// <reference lib="DOM" />
import { AppRegistry } from "react-native";
import { App } from "./src/App";
import { name as appName } from "./app.json";
AppRegistry.runApplication(AppRegistry.registerComponent(appName, function() {
    return App;
}), {
    // eslint-disable-next-line no-undef -- web env
    rootTag: document.getElementById("root")
});
